import { useState } from "react";
import { Minus, Plus } from "lucide-react";

export type FaqItem = { q: string; a: string };

export function Faq({ items, title = "Perguntas frequentes" }: { items: FaqItem[]; title?: string }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div>
      <h2 className="display text-3xl sm:text-4xl">{title}</h2>
      <dl className="mt-8 divide-y divide-border border-y border-border">
        {items.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q}>
              <dt>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                >
                  <span className="text-base font-medium text-foreground">{item.q}</span>
                  {isOpen ? (
                    <Minus className="h-4 w-4 shrink-0 text-nook-green" />
                  ) : (
                    <Plus className="h-4 w-4 shrink-0 text-nook-green" />
                  )}
                </button>
              </dt>
              <dd className={isOpen ? "pb-6 pr-10 text-sm leading-relaxed text-muted-foreground" : "hidden"}>
                {item.a}
              </dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}

export function faqSchema(items: FaqItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((i) => ({
      "@type": "Question",
      name: i.q,
      acceptedAnswer: { "@type": "Answer", text: i.a },
    })),
  };
}
